import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid w-full py-3 px-7 sm:grid-cols-3" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Add Scheduled")

import ScorecardSection from './ScorecardSection.vue';
import { ref, toRefs } from 'vue';
import { useWrestlerStore } from '@/store/wrestlers';
import SearchDropdown from '../Inputs/SearchDropdown.vue';

interface Props {
  scheduleds: Array<string | number>;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    scheduleds: null
  },
  setup(__props: any) {

const props = __props as {
  scheduleds: Array<string | number>;
}



const { scheduleds } = toRefs(props);

const wrestlerStore = useWrestlerStore();

function getWrestler(raw: string | number) {
  if (!isNaN(Number(raw))) {
    const wrestler = wrestlerStore.wrestlers.find((w) => w.SuperstarId === raw);
    if (wrestler) {
      return wrestler.Name;
    }
  }
  return raw;
}

const newScheduled = ref();

function addScheduled() {
  if (!scheduleds.value.includes(newScheduled.value)) {
    scheduleds.value.push(newScheduled.value);
    newScheduled.value = undefined;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(ScorecardSection, { title: "Scheduled Appearances" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scheduleds), (scheduled) => {
          return (_openBlock(), _createElementBlock("div", {
            key: scheduled,
            class: "my-2"
          }, _toDisplayString(getWrestler(scheduled)), 1))
        }), 128)),
        _createElementVNode("div", null, [
          _createVNode(SearchDropdown, {
            modelValue: newScheduled.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newScheduled).value = $event)),
            items: _unref(wrestlerStore).wrestlerSearchOptions
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_Button, { onClick: addScheduled }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})